
























































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import UpdatePersonRequest from '@/models/Customers/People/UpdatePersonRequest';
import { PersonModule } from '@/store/Customers/PersonModule';

@Component({ name: 'PersonEdit' })
export default class extends SaascadaVueDialog {

    request: UpdatePersonRequest = new UpdatePersonRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdatePersonRequest();
            this.request.title = PersonModule.person.title;
            this.request.firstName = PersonModule.person.firstName;
            this.request.lastName = PersonModule.person.lastName;
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await PersonModule.editPerson(this.request)
        }
    }

}
